"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var VISIBLE_CHIPS = 3;
var Chevron = function (_a) {
    var _b;
    var isUp = _a.isUp;
    return (react_1.default.createElement("svg", { width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": true, className: classnames_1.default(styles_module_scss_1.default.chevron, (_b = {}, _b[styles_module_scss_1.default.chevron_up] = isUp, _b)) },
        react_1.default.createElement("path", { d: "M6 9l6 6 6-6" })));
};
var MultiSelectField = function (_a) {
    var _b;
    var label = _a.label, values = _a.values, placeholder = _a.placeholder, isOpen = _a.isOpen, onToggle = _a.onToggle, onChipClick = _a.onChipClick;
    var hidden = values.length - VISIBLE_CHIPS;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.field },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.section_label }, label),
        react_1.default.createElement("button", { type: "button", className: classnames_1.default(styles_module_scss_1.default.field_box, (_b = {},
                _b[styles_module_scss_1.default.field_box_open] = isOpen,
                _b)), onClick: onToggle },
            react_1.default.createElement("span", { className: styles_module_scss_1.default.field_chips },
                !values.length && (react_1.default.createElement("span", { className: styles_module_scss_1.default.placeholder }, placeholder)),
                values.slice(0, VISIBLE_CHIPS).map(function (value, index) {
                    var _a;
                    return (react_1.default.createElement("span", { key: value, className: classnames_1.default(styles_module_scss_1.default.field_chip, (_a = {},
                            _a[styles_module_scss_1.default.field_chip_clickable] = !!onChipClick,
                            _a)), onClick: onChipClick
                            ? function (e) {
                                e.stopPropagation();
                                onChipClick(index);
                            }
                            : undefined }, value));
                }),
                hidden > 0 && (react_1.default.createElement("span", { className: styles_module_scss_1.default.field_chip },
                    "+",
                    hidden))),
            react_1.default.createElement(Chevron, { isUp: isOpen }))));
};
exports.default = MultiSelectField;
